'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RestMiddleware = RestMiddleware;

var _RestErrors = require('./RestErrors');

function RestMiddleware(options) {
    return function* internal(context, next) {
        let request = context.request = {
            body: undefined,
            headers: {},
            method: 'GET',
            params: {},
            url: '' + options.url
        };
        let response = context.response = {
            body: undefined,
            headers: {},
            statusCode: undefined,
            statusText: undefined,
            url: undefined
        };
        let list = context.list,
            create = context.create,
            read = context.read,
            update = context.update,
            remove = context.remove;

        if (list) {
            request.method = 'GET';
            request.url = '' + options.url;
            request.params = list;
            yield* next();
            context.ok = _RestErrors.RestErrors.list(response.statusCode) === false;
            context.error = _RestErrors.RestErrors.list(response.statusCode);
            context.listed = response.body;
        } else if (read) {
            request.method = 'GET';
            request.url = options.url + '/' + read[options.id];
            yield* next();
            context.ok = _RestErrors.RestErrors.read(response.statusCode) === false;
            context.error = _RestErrors.RestErrors.read(response.statusCode);
            context.readed = response.body;
        } else if (create) {
            request.method = 'POST';
            request.url = '' + options.url;
            request.body = create;
            yield* next();
            context.ok = _RestErrors.RestErrors.create(response.statusCode) === false;
            context.error = _RestErrors.RestErrors.create(response.statusCode);
            context.created = response.body;
        } else if (update) {
            request.method = 'PUT';
            request.url = options.url + '/' + update[options.id];
            request.body = update;
            yield* next();
            context.ok = _RestErrors.RestErrors.update(response.statusCode) === false;
            context.error = _RestErrors.RestErrors.update(response.statusCode);
            context.updated = response.body;
        } else if (remove) {
            request.method = 'DELETE';
            request.url = options.url + '/' + remove[options.id];
            yield* next();
            context.ok = _RestErrors.RestErrors.remove(response.statusCode) === false;
            context.error = _RestErrors.RestErrors.remove(response.statusCode);
            context.removed = response.body;
        } else {
            throw new Error('Expecting list, create, read, update or remove');
        }
    };
}
//# sourceMappingURL=RestMiddleware.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/middlewares/RestMiddleware.js